import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { StudyCenterType } from '../entities/study-center-type';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class StudyCenterTypeService extends BaseCrudService<StudyCenterType> {

  public uri = '/api/studyCenterType/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance StudyCenterTypeService');
  }

  buildSentence(entity?: StudyCenterType, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.abbreviation ?
          `abbreviation${QueryOperator.Contain}${entity.abbreviation}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/study-center-type.service.ts